module.exports = __webpack_public_path__ + "img/activities-9.dd1d6f6b.jpg";